import React from 'react';
import {throttle, debounce} from '@/utils/tools';
import './style.scss';

const prefixCls = 'vlist-container';
// 截流频率
const interval = 30;
const triggerRadio = 0.4;

// 无限滚动列表
// TODO：虚拟列表，用于回调
class Vlist extends React.PureComponent {
  constructor(props) {
    super(props);
    this.listRef = React.createRef();
    this.onScroll = throttle(this.onScroll, interval);
    this.loadMore = debounce(this.props.loadMore || (() => {}), 100);
  }

  static defaultProps = {
    data: [],
    renderNode: () => {},
    // 实现无限滚动，加载列表
    loadMore: () => {}
  };

  onScroll = () => {
    this.updateOpitionState();
  }

  updateOpitionState() {
    let $el = this.listRef.current;
    if (!$el) {
      return false;
    }
    let clientHeight = $el.clientHeight;
    let scrollTop = $el.scrollTop;
    let scrollHeight = $el.scrollHeight;

    // 当滚动条的到达底部时，通过回调函数加载更多数据
    if ((scrollHeight - clientHeight - scrollTop) <= triggerRadio * clientHeight) {
      this.props.data.length && this.loadMore();
    }
  }

  componentDidMount() {
    this.listRef && this.listRef.current.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    this.listRef && this.listRef.current.removeEventListener('scroll', this.onScroll);
  }

  render() {
    const {children} = this.props;
    return (
      <div className={prefixCls} onScroll={this.onScroll} ref={this.listRef}>
        {
          this.props.data.map((item, index) => {
            return this.props.renderNode(item, index);
          })
        }
        {
          children && children() || ''
        }
      </div>
    );
  }
}

export default Vlist;
